import "./WhoWeServe.module.css";
import Navbar from "@/reusable_sections/Header";
import Industries from "./sections/Industries";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
import FiftyThree from "./sections/FiftyThree";
export default function WhoWeServePage() {
  return <div>
      <Navbar />
      <Industries />
      <FiftyThree />
      <CallToAction />
      <Footer />
    </div>;
}